import React, { useState } from "react";
import { hero, about } from "../data/data";
import "./Hero.css";
import { FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";

const Hero = () => {
  const [imgError, setImgError] = useState(false);
  return (
    <section className="hero" id="hero">
      <div className="hero-bg"></div>
      <div className="hero-content">
        <div className="hero-photo-wrapper">
          {!imgError ? (
            <img
              src={hero.photoPlaceholder}
              alt={hero.photoAlt}
              onError={() => setImgError(true)}
            />
          ) : (
            <span className="img-placeholder"></span>
          )}
        </div>
        <h1 className="hero-name">{hero.heading}</h1>
        <p className="hero-role">{hero.subheading}</p>
        <div className="hero-actions">
          {/* <a href={about.cvLink} className="btn-primary" download>
            {about.cvLabel}
          </a> */}
          <div className="hero-socials">
            <a
              href="https://www.linkedin.com/in/mateusz-stelmaszczyk-4b32131a2/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn">
              {/* <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
                <path
                  fill="#ffb400"
                  d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.28c-.97 0-1.75-.79-1.75-1.75s.78-1.75 1.75-1.75 1.75.79 1.75 1.75-.78 1.75-1.75 1.75zm15.5 10.28h-3v-4.5c0-1.08-.02-2.47-1.5-2.47-1.5 0-1.73 1.17-1.73 2.39v4.58h-3v-9h2.89v1.23h.04c.4-.75 1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 4.59v4.72z"
                />
              </svg > */}
              <FaLinkedinIn className="social-icons" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100018118715785"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook">
              {/* <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
                <path
                  fill="#ffb400"
                  d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.205 11.387.6.113.82-.262.82-.582 0-.288-.012-1.243-.017-2.252-3.338.726-4.042-1.415-4.042-1.415-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.083-.729.083-.729 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.108-.775.418-1.305.762-1.606-2.665-.304-5.466-1.332-5.466-5.931 0-1.31.469-2.381 1.236-3.221-.124-.303-.535-1.523.117-3.176 0 0 1.008-.322 3.3 1.23.957-.266 1.984-.399 3.003-.404 1.018.005 2.046.138 3.006.404 2.289-1.552 3.295-1.23 3.295-1.23.653 1.653.242 2.873.119 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.804 5.625-5.475 5.921.43.371.823 1.102.823 2.222 0 1.606-.015 2.898-.015 3.293 0 .322.216.699.825.58C20.565 21.796 24 17.297 24 12c0-6.63-5.373-12-12-12z"
                />
              </svg> */}
              <FaFacebookF className="social-icons" />
            </a>
            <a href="mailto:mathy1987s@gmail.com" aria-label="E-mail">
              {/* <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
                <path
                  fill="#ffb400"
                  d="M12 13.065l-8-5.065v10a2 2 0 002 2h12a2 2 0 002-2v-10l-8 5.065zm8-7.065a2 2 0 00-2-2h-12a2 2 0 00-2 2v.217l8 5.066 8-5.066v-.217z"
                />
              </svg> */}
              <IoIosMail className="social-icons" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
